import { getStatusBgColor, getStatusTextColor } from '@/pages/oms/orders/utils/statusColor';
import { csResolutionMethodLabel } from '@/utils/fulfillmentCsResolution';

/** CS vocabulary uses the familiar palette, but never derives state from WooCommerce. */
export const CsStatusBadge = ({
  status,
  resolutionMethod,
}: {
  status: string;
  resolutionMethod?: string | null | undefined;
}) => {
  const paletteKey =
    status === 'delivered' || status === 'resolved'
      ? 'completed'
      : status === 'canceled'
        ? 'cancelled'
        : status.replace(/-/g, '_');
  // Resolved is only half the record without how; the method rides along so the list and detail read alike.
  const text =
    status === 'resolved'
      ? resolutionMethod
        ? `Resolved · ${csResolutionMethodLabel(resolutionMethod)}`
        : 'Resolved'
      : status;
  return (
    <span
      className="d-inline-block rounded px-2"
      style={{ color: getStatusTextColor(paletteKey), backgroundColor: getStatusBgColor(paletteKey) }}
    >
      {text}
    </span>
  );
};
